export enum ListFilter {
  ALL = 'all',
  SOME_ACTIVE = 'some_active',
  EU_ACTIVE = 'end_user_active',
  EU_NAME_SEARCH = 'end_user_name_search',
  EU_NOT_STARTED = 'end_user_not_started',
  UNREAD_ONLY = 'unread_only',
  SCHEDULED_MESSAGES_ONLY = 'scheduled_messages_only',
}
